import React, { useState } from 'react';
import axios from 'axios';
import '../../styles/AuthForm.css';
import { Link, useParams } from 'react-router-dom';
import CustomButton from '../../components/CustomButton';
import RightComponent from './RightSideComponent';
import logo from '../../images/logo.png';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import CustomModal from '../../components/CustomModal';
import Typography from '../../components/Typography';

const ResetPassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [message, setMessage] = useState('');
    const { token } = useParams();
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState('success'); // or 'error'
    const [modalMessage, setModalMessage] = useState('');
    const [title , setTitle] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setMessage("Passwords do not match.");
            return;
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/reset-password/${token}`, { password });
            setModalType('success');
            setTitle('PASSWORD RESET!')
            console.log(response.data.message);
            setModalMessage(/* response.data.message || */ 'Password reset successful. You can now log in.');
            setShowModal(true);
        } catch (error) {
            setTitle('OH SNAP!');
            setModalType('error');
            console.log(error.response?.data?.message);
            setModalMessage(/* error.response?.data?.message || */ 'Oops! We ran into an issue saving your password. Try again please.');
            setShowModal(true);
        }
    };

    return (
        <div className='grid grid-cols-7 min-h-screen'>
            <Link to={'https://ashcapital.com'} className='lg:left-9 left-1/2 transform -translate-x-1/2 lg:translate-x-0 ' style={{ position: 'absolute', top: '36px',}}><img src={logo} alt='logo'  /></Link> 
            <Link to={'/forgot-password'} style={{ position: 'absolute', top: '126px', left: '36px' }} className='flex' ><Typography className='mr-1' text={'<'} family={'Supply'} color={'#DF0F11'} size={'18.462px'} transform={'uppercase'} weight={400} lineheight={'130%'} /> <Typography family={'Supply'} text={'GO BACK'} color={'#FFFFFF'} size={'18.462px'} transform={'uppercase'} weight={400} lineheight={'130%'} /></Link> 
            <div className='lg:col-span-4  col-span-7 px-4  flex justify-center items-center h-screen  bg-[#0F0F0F] text-center lg:text-left'>
                {showModal && (
                    <CustomModal
                        type={modalType}
                        title={title}
                        message={modalMessage}
                        onClose={() => setShowModal(false)}
                    />
                )}
                <div className="py-48 mx-auto w-[464px]">
                    <div className='auth-header text-center lg:text-left'>RESET PASS</div>
                    <div className='auth-desc'>Please enter your new password.</div>

                    {message && <p className="text-red-500 mt-2">{message}</p>}

                    <form onSubmit={handleSubmit}>
                        {/* Password Field */}
                        <div className="relative z-0 w-full mb-5 group mt-10">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                name="password"
                                id="password"
                                className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 placeholder-white/40"
                                value={password}
                                placeholder='New Password'
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <div className="absolute right-3 top-3 text-gray-500 cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </div>
                        </div>

                        {/* Confirm Password Field */}
                        <div className="relative z-0 w-full mb-5 group mt-10">
                            <input
                                type={showConfirmPassword ? 'text' : 'password'}
                                name="confirm_password"
                                id="confirm_password"
                                placeholder='Confirm Password'
                                className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 placeholder-white/40"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                            />
                            <div className="absolute right-3 top-3 text-gray-500 cursor-pointer" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                            </div>
                        </div>

                        <CustomButton type='submit' className='mt-8' text={'Reset password'} />
                    </form>
                </div>
            </div>
            <div className="lg:col-span-3 lg:flex hidden">
                <RightComponent />
            </div>
        </div>
    );
};

export default ResetPassword;
